import axios, { AxiosInstance, AxiosRequestConfig } from 'axios'

import { getEnv, redirectToLogin } from 'src/utils/env'

type RequestConfig = {
    requiresAuth?: boolean
} & Omit<AxiosRequestConfig, 'url' | 'method'>
type PrivateRequestConfig = {
    requiresAuth?: boolean
} & AxiosRequestConfig

export abstract class HttpClientBase {
    private client: AxiosInstance

    constructor(clientConfig: AxiosRequestConfig<any> = {}) {
        this.client = axios.create(clientConfig)
    }

    protected async get<T = any>(url: string, config?: RequestConfig) {
        return this.request<T>({ method: 'get', url, ...config })
    }

    protected async post<T = any>(url: string, config?: RequestConfig) {
        return this.request<T>({ method: 'post', url, ...config })
    }

    protected async put<T = any>(url: string, config?: RequestConfig) {
        return this.request<T>({ method: 'put', url, ...config })
    }

    protected async patch<T = any>(url: string, config?: RequestConfig) {
        return this.request<T>({ method: 'patch', url, ...config })
    }

    protected async delete<T = any>(url: string, config?: RequestConfig) {
        return this.request<T>({ method: 'delete', url, ...config })
    }

    protected async request<T>(config: PrivateRequestConfig) {
        try {
            const { data } = await this.client.request<T>(config)

            return data
        } catch (error: any) {
            if (config.requiresAuth && getEnv() !== 'dev' && axios.isAxiosError(error) && error.response?.status === 401) {
                redirectToLogin()
            }

            throw error
        }
    }
}
